import { type AxiosError } from 'axios'
import { createEffect, createEvent } from 'effector'

import { ERROR_CODE, HTTP_STATUS } from '../../lib/constants'
import {
  ApiError,
  AuthError,
  type KnownApiError,
  NetworkError,
  NotFoundError,
} from '../../lib/types/errors'

function parseApiError(data: unknown): ApiError | null {
  if (!data || typeof data !== 'object') return null

  const candidate = data as Partial<KnownApiError>

  if (
    'message' in candidate &&
    'errorCode' in candidate &&
    candidate.message !== undefined &&
    candidate.errorCode !== undefined
  ) {
    return new ApiError({
      code: candidate.errorCode,
      message: candidate.message,
      data,
    })
  }

  if (
    'Message' in candidate &&
    'ErrorCode' in candidate &&
    candidate.Message !== undefined &&
    candidate.ErrorCode !== undefined
  ) {
    return new ApiError({
      code: candidate.ErrorCode,
      message: candidate.Message,
      data,
    })
  }

  return null
}

export const apiRequestError = createEvent<Error>()

export const errorHandlerFx = createEffect((error: AxiosError) => {
  const { response, code } = error

  if (response) {
    const { status, statusText, data } = response

    if (status === HTTP_STATUS.UNAUTHORIZED) {
      throw new AuthError(statusText)
    }

    if (status === HTTP_STATUS.NOT_FOUND) {
      throw new NotFoundError(statusText)
    }

    const parsed = parseApiError(data)
    if (parsed) throw parsed

    throw new ApiError({
      code: status,
      message: statusText,
      data,
    })
  }

  if (code === ERROR_CODE.NETWORK) {
    throw new NetworkError(
      'Проверьте подключение к интернету или повторите попытку позже',
    )
  }

  throw error
})
